import { Component } from '@angular/core';

@Component({
  selector: 'app-colabs-block',
  templateUrl: './colabs-block.component.html'
})
export class ColabsBlockComponent {}
